import type { StageMap } from '@/types/project'
import { STAGE_COUNT } from './stages'

export interface StageCounts {
  green: number
  red: number
  na: number
  /** Stages that count toward completion (total minus Not-applicable). */
  applicable: number
}

/** Tally stage statuses. Any missing/unknown status is treated as Not completed. */
export function stageCounts(stages: StageMap | undefined, total = STAGE_COUNT): StageCounts {
  let green = 0
  let na = 0
  for (let stage = 1; stage <= total; stage += 1) {
    const status = stages?.[String(stage)]?.status
    if (status === 'green') {
      green += 1
    } else if (status === 'na') {
      na += 1
    }
  }
  return { green, red: total - green - na, na, applicable: total - na }
}

/**
 * Completion percentage over *applicable* stages (Not-applicable stages are
 * excluded from the denominator). 0 when every stage is Not-applicable.
 */
export function completionPercent(stages: StageMap | undefined, total = STAGE_COUNT): number {
  const { green, applicable } = stageCounts(stages, total)
  return applicable > 0 ? Math.round((green / applicable) * 100) : 0
}
